import { DatePicker, Text } from '@thefarmersfront/kitchen';

import dayjs, { Dayjs } from 'dayjs';

import { getDateByOffset } from '~/utils/date';

import styles from '../DeliveryAgencyDeliveryStatusBoard.module.scss';

interface DeliveryAgencyDeliveryStatusRealtimeHeaderProps {
  estimatedDeliveryDate: Dayjs;
  onChangeEstimatedDeliveryDate: (date: Dayjs) => void;
}

const getMinDate = () => dayjs().subtract(3, 'month').startOf('month').toDate();

const getMaxDate = () => getDateByOffset(1, 'day');

const DeliveryAgencyDeliveryStatusRealtimeHeader = ({
  estimatedDeliveryDate,
  onChangeEstimatedDeliveryDate,
}: DeliveryAgencyDeliveryStatusRealtimeHeaderProps) => {
  return (
    <div className={styles['section-header']}>
      <Text size="xxlarge" weight="bold">
        실시간 배송 현황
      </Text>

      <div style={{ width: 228 }}>
        <DatePicker
          size="medium"
          minDate={getMinDate()}
          maxDate={getMaxDate()}
          value={estimatedDeliveryDate.toDate()}
          onChange={(value: Date | null) => {
            if (!value) return;
            onChangeEstimatedDeliveryDate(dayjs(value));
          }}
        />
      </div>
    </div>
  );
};

export { DeliveryAgencyDeliveryStatusRealtimeHeader };
